<h1><a (click)="onClick()">Click</a></h1>
<div aria-live="polite" toastContainer></div>
